const LS_KEY = `superadmin_active_sessions`;

function b64DecodeUnicode(str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(str).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}

function addSession(base64_data) {
    const { name, sid } = JSON.parse(
        b64DecodeUnicode(base64_data)
    );

    const array = get() || [];

    const existing = array.find(a => a.sid == sid || a.name == name);

    if (existing) return;

    array.push({
        name,
        sid,
        expires: Date.now() + (3 * 24 * 60 * 60 * 1000)
    });

    window.localStorage.setItem(LS_KEY, JSON.stringify(array.slice(0,5)));
}

function get() {
    const value = window.localStorage.getItem(LS_KEY);

    if (!value) return null;

    return JSON.parse(value).filter(v => v.expires >= Date.now());
}

export default {
    get,
    addSession
}